import React, { useCallback, useMemo, useContext } from 'react'
import OptionsMenu from '../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../components/SectionFormContainer'
import BoardingWizardContext from './BoardingWizardContext'
import useBoardingVisit from '../../../hooks/useBoardingVisit'
import { formatNumsToDollars } from '../../../utils'

const KennelSharing = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(BoardingWizardContext)
	const { attr, title = '', subtext = '' } = props
	const { loading, boarding } = useBoardingVisit()

	const handleSelection = useCallback(
		(type) => {
			const newValues = { ...wizard_state }
			newValues[attr] = type
			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	const options = useMemo(() => {
		if (!boarding) {
			return []
		}
		const { overnights_price, overnights_price_shared } = boarding

		const o = [
			{
				title: 'Yes, I want my dogs to share a kennel overnight',
				description: `${formatNumsToDollars(
					overnights_price_shared
				)} per kennel per night for a shared kennel (2 dogs max in a shared kennel)`,
				disabled: loading || wizard_state[attr] === true,
				selected: wizard_state[attr] === true,
				onSelected: () => handleSelection(true)
			},
			{
				title: `No, my dogs each need their own kennel overnight`,
				description: `Standard rate of ${formatNumsToDollars(overnights_price)} applies`,
				disabled: loading || wizard_state[attr] === false,
				selected: wizard_state[attr] === false,
				onSelected: () => handleSelection(false)
			}
		]

		return o
	}, [handleSelection, loading, wizard_state, attr, boarding])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<OptionsMenu options={options} />
		</SectionFormContainer>
	)
}

export default KennelSharing
